import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import { resetForm } from '../store/reducers/registrationSlice';

import { translate } from "../i18n";
import CompanyFormSteps from "./CompanyFormSteps";
import NonCompanyFormSteps from "./NonCompanyFormSteps";
import {editUserType, resetUserType} from "../store/reducers/userTypeSlice";
import { endpoints } from "../servics/apiEndpoints";
  
const RegistrationForm = () => {
    const dispatch = useDispatch();
    const language_code = useSelector(state => state.lang);
    const actualCountry = useSelector((state) => state.country.country);
     const countryCode = actualCountry && actualCountry.value
      ? actualCountry.value.toLowerCase()
      : 'tg';

    // useEffect(() => {
    //       console.log("Language code in forms:", language_code);
    //       console.log("Actual country in forms:", actualCountry);
    //     }, [actualCountry]);

    const navigate = useNavigate();
    const {
        files,
        companyFormFields,
        regularFormFields
    } = useSelector(state => state.registration);

    const {
        userType,
        type
    } = useSelector(state => state.userType);

    const {
        country
    } = useSelector(state => state.country.country);

    const {
        register,
        handleSubmit,
        watch,
        getValues,
        setValue,
        formState: { errors, isValid },
        control,
    } = useForm({
        mode: 'onChange',
        reValidateMode: 'onChange',
        defaultValues: userType === 'company' ? companyFormFields : regularFormFields
    });

    // 🔽 Get the full registration state
    const registration = useSelector(state => state.registration);

    // 🔽 Dynamically select the correct form fields based on user type
    let formFields = {};
    if (userType === 'company') {
        formFields = registration.companyFormFields;
    } else if (userType === 'nonCompany') {
        formFields = registration.regularFormFields;
    } else if (userType === 'hero') {
        formFields = registration.heroFormFields;
    }
    

    const [feedback, setFeedback] = useState({ message: '', type: '' });

    const buildFormData = (formFields, files) => {
        const formData = new FormData();

        // Append the JSON object as 'requestDto'
        formData.append(
            "requestDto",
            new Blob([JSON.stringify(formFields)], {
                type: "application/json",
            })
        );
        // Append files
        files.forEach((file) => {
            formData.append("files", file);
        });
        return formData;
    };

    const onFormSubmit = async (data) => {
        // console.log('Formulaire enrichi et complet :', data);

        let endpoint = null;
        if (userType === "hero") {
            endpoint = endpoints.hero;
        } else if (userType === "company") {
            endpoint = endpoints.company;
        } else if (userType === "nonCompany") {
            endpoint = endpoints.nonCompany;
        } else {
            toast.error("Veuillez sélectionner un type de compte.");
            return;
        }

        try {
            let response;

            if (userType === "company" || userType === "hero") {
                // Multipart ; l'entreprise n'envoie plus de pièces : elle les dépose depuis « Mes documents ».
                const formData = buildFormData(data, userType === "hero" ? files : []);
                // response = await axios.post(endpoint, formData, {
                //     headers: {
                //         "Content-Type": "multipart/form-data",
                //     },
                // });
                response = await axios.post(endpoint, formData);
            } else {
                // Regular JSON for users without files
                response = await axios.post(endpoint, data, {
                    headers: {
                        "Content-Type": "application/json",
                    },
                });
            }

            if (response.status === 201 || response.status === 200) {
                toast.success("Préinscription effectuée avec succès ! Consultez vos mails pour poursuivre");
                dispatch(resetForm());
                dispatch(resetUserType());
                //  navigate("/signup-success"); <- redirect to the AfterSignup component
            } else {
                toast.error("Vos données sont incorrectes.");
            }
        } catch (error) {
            if (error.response) {
                const backendError = error.response.data;

                // on essaie différents champs possibles
                const errorMessage = backendError.detail
                    || backendError.errorMessage
                    || backendError.title
                    || "Une erreur est survenue côté serveur.";

                // console.error("Erreur backend:", backendError);
                toast.error(errorMessage);

            } else if (error.request) {
                // console.error("Aucune réponse du serveur:", error.request);
                toast.error("Le serveur ne répond pas. Vérifiez votre connexion.");
            } else {
                // console.error("Erreur lors de la configuration de la requête:", error.message);
                toast.error("Erreur interne du client.");
            }
        }
    };

    useEffect(() => {
        if (feedback.message) {
            const timer = setTimeout(() => setFeedback({ message: '', type: '' }), 5000);
            return () => clearTimeout(timer);
        }
    }, [feedback]);

    useEffect(() => {
        // console.log("The type :", type)
        // console.log("The userType :", userType)
    });

    return (
        <div>
            <ToastContainer position="top-center" autoClose={5000} />
            <form className="d-flex flex-column gap-15" onSubmit={handleSubmit(onFormSubmit)}>

                {/* Account Type Selection */}
                {/* Company account checkbox */}
                {(
                    type.isCompany ||
                    (!type.isSwitched && userType === ' ') ||
                    (!type.isSwitched && userType !== 'company' && userType !== 'nonCompany')
                ) && (
                    <div className="radio-box form-check pt-2">
                        <input
                            type="checkbox"
                            className="form-check-input"
                            checked={userType === 'company'}
                            onChange={() => {
                                if (userType === 'company') {
                                    dispatch(resetUserType());
                                } else {
                                    dispatch(editUserType('company'));
                                }
                            }}
                        />
                        <label className="form-check-label">
                            {translate('signup', language_code.lang).create_company_account}
                        </label>
                        <p className="small-text">
                            {translate('signup', language_code.lang).company_account_description}
                        </p>
                    </div>
                )}


                {/* Regular account checkbox */}
                {(
                    type.isNonCompany ||
                    (!type.isSwitched && userType === ' ') ||
                    (!type.isSwitched && userType !== 'company' && userType !== 'nonCompany')
                ) && (
                    <div className="radio-box form-check pt-2">
                        <input
                            type="checkbox"
                            className="form-check-input"
                            checked={userType === 'nonCompany'}
                            onChange={() => {
                                if (userType === 'nonCompany') {
                                    dispatch(resetUserType());
                                } else {
                                    dispatch(editUserType('nonCompany'));
                                }
                            }}
                        />
                        <label className="form-check-label">
                            {translate('signup', language_code.lang).create_regular_account}
                        </label>
                        <p className="small-text">
                            {translate('signup', language_code.lang).regular_account_description}
                        </p>
                    </div>
                )}

                {/* Conditional Form Fields */}
                {(type.isSwitched && userType === 'company') && (
                    <CompanyFormSteps
                        register={register}
                        watch={watch}
                        errors={errors}
                        formFields={formFields}
                        control={control}
                        getValues={getValues}
                        setValue={setValue}
                        countryCode={countryCode}
                        onFinalSubmit={onFormSubmit}
                    />
                )}

                {(type.isSwitched && userType === 'nonCompany') && (
                    <NonCompanyFormSteps
                        register={register}
                        watch={watch}
                        errors={errors}
                        formFields={formFields}
                        control={control}
                        getValues={getValues}
                        setValue={setValue}
                        countryCode={countryCode}
                        onFinalSubmit={onFormSubmit}
                    />
                )}

                {/* Link for Agri Hero */}
                {/* Agri hero link */}
                {(
                    (!type.isSwitched && userType === ' ') ||
                    (!type.isSwitched && userType !== 'company' && userType !== 'nonCompany')
                ) && (
                    <div className="mt-3 d-flex align-items-center justify-content-center">
                        <Link className="buttonBusiness" to="/hero-registration">
                            {translate('signup', language_code.lang).agri_hero_invitation_button}
                        </Link>
                    </div>
                )}

                {/* Feedback */}
                {feedback.message && (
                    <span
                        style={{
                            color: feedback.type === 'success' ? 'green' : 'red',
                            marginTop: '10px',
                            fontWeight: 'bold',
                            display: 'block',
                        }}
                    >
                        {feedback.message}
                    </span>
                )}
            </form>
        </div>
    );
};

export default RegistrationForm;
